/**
 * @author      julian@zumper.com (Julian Napolitan)
 * @copyright   Copyright (c) 2025, Zumper
 */

import type { CardBackReviewsSummary } from '@zcode/state-type'

interface ListingCardReviewProps {
  isSpotlight?: true
  reviewsSummary: CardBackReviewsSummary
}

export const ListingCardReviewsSummary = ({
  isSpotlight,
  reviewsSummary,
}: ListingCardReviewProps) => {
  const { text } = reviewsSummary

  return (
    <div
      className={`flex flex-col gap-y-1 text-sm ${isSpotlight ? 'text-neutral-200' : 'text-gray-600'}`}
    >
      <div className={`font-bold ${isSpotlight ? 'text-gray-0' : 'text-gray-950'}`}>
        Summary of resident reviews
      </div>
      <p>{text}</p>
    </div>
  )
}
